import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const watermarksSlice = createAppSlice({
  name: 'watermarks',
  initialState,
  reducers,
});

export const {
  loadWatermarkSets,
  createWatermarkSet,
  updateWatermarkSet,
  deleteWatermarkSet,
  setCurrentWatermarkSet,
  clearCurrentWatermarkSet,
  resetWatermarksReducer,
} = watermarksSlice.actions;

export default watermarksSlice.reducer;
